import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ShowDefaultPartnerContact } from 'common/utils/featureFlags';
import { getPatient } from 'store/thunks/patientThunks';

import choosePartnerContactForOrder from '../utils/choosePartnerContactForOrder';

/**
 * The patient's email and phone as the given partner has them, chosen the way the order page does:
 * the partner's own value, else the patient's default (only with the default-contact switch on).
 * Loads the patient's per-partner contacts once if the store does not hold them yet; undefined
 * until they are there.
 */
const usePartnerContactForPatient = ({ mpi, partnerUuid }) => {
  const dispatch = useDispatch();
  const patient = useSelector(({ patient: patientsByMpi }) => patientsByMpi[mpi]);
  const hasContactsFromPartners = Array.isArray(patient?.contactsFromPartners);

  useEffect(() => {
    if (mpi && !hasContactsFromPartners) {
      dispatch(getPatient({ mpi }));
    }
  }, [dispatch, mpi, hasContactsFromPartners]);

  if (!hasContactsFromPartners) {
    return undefined;
  }

  return choosePartnerContactForOrder({
    patient,
    partnerUuid,
    isDefaultContactShown: ShowDefaultPartnerContact,
  });
};

export default usePartnerContactForPatient;
